import * as types from "../types";

export const logoutRequest = () => ({
  type: types.LOGOUT_REQUEST,
});
